<template>
  <div class="container">
    <breadcrumb></breadcrumb>
    <div class="select-box input_left">
      <Input v-model="searchAppName" style="width:150px;" placeholder="请输入插件名称" :rows="4" />
    </div>
    <div class="select-box input_left_two">
      <Input v-model="searchMac" style="width:150px;" placeholder="请输入mac地址" :rows="4" />
    </div>
    <div class="select-box input_left_three">
      <Button type="primary" @click="searchBtn"  style="margin-right:5px;">查询</Button>
      <Button type="primary" @click="searchClear" >重置</Button>
    </div>
    <div class="option-wrap-channel" style="margin-top:20px;">
      <Row>
        <Col >
          <Button type="primary" @click="addMac">新增</Button>
        </Col>
      </Row>
    </div>
    <Table :loading="tableLoading" class="spacingTwice" border :columns="columns" :data="dataList"></Table>
    <Page show-total :total="total" :current="current" :page-size="pageSize"
          @on-change="pageChange" @on-page-size-change="pageSizeChange" show-sizer />
    <Modal
      width="600"
      :mask-closable="false"
      v-model="isShowEdit"
      :title="formType === 1?'修改测试mac': '新增测试mac'"
      :loading="loading"
      @on-ok="editData('formEdit')">
      <Form ref="formEdit" :model="formEdit" :rules="ruleValidate"  :label-width="120">
        <FormItem label="设备mac地址" prop="macs" style="margin-bottom:0px;">
          <Input v-model="formEdit.macs" type="textarea" :rows="2" />
          <p>* 多个mac地址请用英文逗号隔开 示例：ecfa5cbc6aaf</p>
        </FormItem>
        <FormItem label="选择分组" prop="groupName">
          <RadioGroup v-model="formEdit.groupName" @on-change="changeGroupName">
              <Radio label=""><span>正式分组</span></Radio>
              <Radio label="test"><span>测试分组</span></Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="插件分类">
          <RadioGroup v-model="formEdit.bigPluginType" @on-change="pluginTypeChange">
              <Radio label="sdk"></Radio>
              <Radio label="apk"></Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="指定插件" prop="pluginId">
          <!-- pluginId -->
          <Select
                v-model="formEdit.pluginId"
                placeholder="名称模糊搜索"
                filterable
                @on-select="appNameCheck"
                >
                <Option v-for="(option, index) in dataSdkList" :value="option.id" :tag="option" :key="index">{{option.pluginTitle}}</Option>
            </Select>
        </FormItem>
        <FormItem label="指定ID" prop="pluginVerId">
          <Select v-model="formEdit.pluginVerId" :filterable="true" id="pluginVerId">
                <Option v-for="(option, index) in appVersionList" :value="option.id" :tag="option" :key="index">{{`${option.pluginVerName} (${option.id})`}}</Option>
            </Select>
        </FormItem>
        <FormItem label="测试时间" prop="deadline">
          <RadioGroup v-model="formEdit.deadline">
              <Radio label="forever"><span>长期有效</span></Radio>
              <Radio label="today"><span>当日有效(次日0点自动失效)</span></Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="备注" prop="remarks">
          <Input v-model="formEdit.remarks" type="textarea" :rows="4" />
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import breadcrumb from '@/components/global/breadcrumb'
import https from '../https'
import utils from '../utils'
export default {
  name: 'testUsers',
  data () {
    return {
      loading: true,
      tableLoading: true,
      checkdata: false,
      dataSource: [], // table数据源
      formType: 0,
      isShowEdit: false,
      searchAppName: '',
      searchMac: '',
      appVersionList: [],
      appName: '',
      devicesId: '',
      dataSdkList: [],
      dataApkList: [],
      formEdit: {
        bigPluginType: 'sdk',
        macs: '',
        groupName: '',
        pluginId: '',
        pluginVerId: '',
        deadline: 'forever',
        remarks: ''
      },
      ruleValidate: {
        macs: [{ required: true, message: ' ' }],
        pluginId: [{ required: true, message: '请选择指定插件' }],
        // enableStatus: [{ required: true, message: '请选择启用状态' }]
        pluginVerId: [{ required: true, message: '请选择指定ID' }]
      },
      columns: [ // table表格
        {
          title: 'ID',
          key: 'id',
          width: 200,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '状态',
          key: 'status',
          minWidth: 100,
          align: 'center',
          render: (h, params) => {
            let status = ''
            switch (params.row.status) {
              case 1:
                status = '生效'
                break
              case 0:
                status = '不生效'
                break
            }
            return h('span', status)
          }
        },
        {
          title: '设备mac地址',
          key: 'macs',
          minWidth: 300,
          align: 'center'
        },
        {
          title: '插件分类',
          key: 'bigPluginType',
          minWidth: 100,
          align: 'center'
        },
        {
          title: '指定插件',
          key: 'pluginTitle',
          minWidth: 200,
          align: 'center'
        },
        {
          title: '指定插件版本',
          key: 'pluginVerId',
          minWidth: 150,
          align: 'center'
        },
        {
          title: '测试时限',
          key: 'deadline',
          minWidth: 200,
          align: 'center',
          render: (h, params) => {
            let status = ''
            if (params.row.deadline === 'forever') {
              status = '长期有效'
            } else {
              status = params.row.expireDate
            }
            return h('span', status)
          }
        },
        {
          title: '备注',
          key: 'remarks',
          minWidth: 200,
          align: 'center'
        },
        {
          title: '操作',
          width: 200,
          align: 'center',
          fixed: 'right',
          render: (h, params) => {
            let btn = []
            btn = [
              h('Button', {
                props: {
                  type: 'success',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.editAlert(params.row)
                  }
                }
              }, '修改'),
              h('Button', {
                props: {
                  type: 'success',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    if (params.row.status === 1) {
                      this.editStatus(params.row, 0)
                    } else if (params.row.status === 0) {
                      this.editStatus(params.row, 1)
                    }
                  }
                }
              }, params.row.status === 1 ? '不生效' : '生效'),
              h('Button', {
                props: {
                  type: 'success',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    // this.apkInfo = JSON.parse(params.row.args)
                    // this.apkInfo.channel = params.row.channel
                    this.delMac(params.row.id)
                  }
                }
              }, '删除')
            ]
            return h('div', btn)
          }
        }
      ],
      dataList: [], // tab当前页数据
      total: 0, // tab总条数
      pageSize: 10, // 每页多少条
      current: 1 // 当前页
    }
  },
  components: {
    breadcrumb
  },
  created () {
    if (!https.token) {
      this.$router.push('/')
      return
    }
    this.loadData()
    this.getSdkList()
  },
  methods: {
    formatDay: utils.formatDay,
    pluginTypeChange () {
      this.formEdit.pluginId = ''
      this.formEdit.pluginVerId = ''
      if (this.formEdit.bigPluginType === 'apk') {
        this.getApkList()
      } else if (this.formEdit.bigPluginType === 'sdk') {
        this.getSdkList()
      }
    },
    changeGroupName (val) {
      this.pluginTypeChange()
      this.formEdit.pluginId = ''
      this.formEdit.pluginVerId = ''
    },
    getApkList () {
      let params = {
        pageSize: 300,
        pageNo: 1,
        groupName: this.formEdit.groupName
      }
      https.request({
        method: 'get',
        url: 'extscreenapi/plugin/hili/esApkPlugin/list',
        params: params
      }).then(res => {
        this.dataSdkList = res.result.records
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    getSdkList () {
      let params = {
        pageSize: 300,
        pageNo: 1,
        groupName: this.formEdit.groupName
      }
      https.request({
        method: 'get',
        url: 'extscreenapi/plugin/hili/esAppPlugin/list',
        params: params
      }).then(res => {
        this.dataSdkList = res.result.records
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    // 加载tabs列表
    searchBtn () {
      this.loadData()
    },
    searchClear () {
      this.searchAppName = ''
      this.searchMac = ''
      this.loadData()
    },
    delMac (id) {
      https.request({
        method: 'delete',
        url: 'extscreenapi/plugin/hili/esPluginMac/delete',
        params: {
          id: id
        }
      }).then(res => {
        this.loadData()
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    addMac () {
      this.$refs['formEdit'].resetFields()
      this.isShowEdit = true
      this.formType = 0
    },
    appNameCheck (query) {
      this.formEdit.pluginVerId = ''
      if (this.formEdit.bigPluginType === 'sdk') {
        this.getSdkSce(query.tag.id)
      } else {
        this.getApkSce(query.tag.id)
      }
      // this.appVersionList = ['不指定版本', ...query.tag.package_vers]
    },
    getSdkSce (id) {
      let params = {
        column: 'createTime',
        order: 'desc',
        pageSize: 200,
        pageNo: 1,
        pluginId: id,
        groupName: this.formEdit.groupName
      }
      https.request({
        method: 'get',
        url: 'extscreenapi/plugin/hili/esAppPluginApk/list',
        params: params
      }).then(res => {
        this.appVersionList = res.result.records
      })
    },
    getApkSce (id) {
      let params = {
        column: 'createTime',
        order: 'desc',
        pageSize: 200,
        pageNo: 1,
        pluginId: id,
        query: 0,
        groupName: this.formEdit.groupName
      }
      https.request({
        method: 'get',
        url: 'extscreenapi/plugin/hili/esApkPluginApk/list',
        params: params
      }).then(res => {
        this.appVersionList = res.result.records
      })
    },
    getSecAppList (appName) {
      let params = {
        page_size: 100,
        page: 1,
        es_app_name: appName,
        package_ver: ''
      }
      https.request({
        method: 'get',
        url: 'v1/test/apps',
        params: params
      }).then(res => {
        res.data.map(item => {
          if (item.name === appName) {
            this.appVersionList = item.package_vers
          }
        })
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    loadData () {
      let params = {
        column: 'createTime',
        order: 'desc',
        pageSize: this.pageSize,
        pageNo: this.current,
        pluginTitle: `*${this.searchAppName}*`,
        macs: `*${this.searchMac}*`
      }
      https.request({
        method: 'get',
        // url: '/v1/test/devices',
        url: 'extscreenapi/plugin/hili/esPluginMac/list',
        params: params
      }).then(res => {
        this.tableLoading = false
        this.dataSource = res.result.records || []
        this.total = res.result.total
        this.dataList = res.result.records
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    editAlert (row) {
      if (row.bigPluginType === 'sdk') {
        this.getSdkList()
        this.getSdkSce(row.pluginId)
      } else {
        this.getApkList()
        this.getApkSce(row.pluginId)
      }
      setTimeout(() => {
        this.formEdit = {
          macs: row.macs,
          pluginId: row.pluginId,
          bigPluginType: row.bigPluginType,
          pluginVerId: row.pluginVerId,
          deadline: row.deadline === 'forever' ? 'forever' : 'today',
          remarks: row.remarks,
          groupName: row.groupName || ''
        }
        this.$refs['formEdit'].resetFields()
        this.isShowEdit = true
        this.formType = 1
        this.devicesId = row.id
      }, 1000)
    },
    editStatus (row, type) {
      console.log(row)
      https.request({
        method: 'put',
        url: `extscreenapi/plugin/hili/esPluginMac/edit`,
        data: {
          id: row.id,
          macs: row.macs,
          pluginId: row.pluginId,
          bigPluginType: row.bigPluginType,
          pluginVerId: row.pluginVerId,
          deadline: row.deadline === 'forever' ? 'forever' : 'today',
          // deadline: type === 2 ? 'forever' : 'today',
          status: type,
          remarks: row.remarks
        }
      }).then(res => {
        this.loadData()
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    // 数据静态分页
    setData () {
      this.dataList = []
      // this.total = this.dataSource.length
      for (let i = (this.current - 1) * this.pageSize; i < this.current * this.pageSize; i++) {
        if (i === this.total) return false
        this.dataList.push(this.dataSource[i])
      }
    },
    editData (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.changeLoading()
          if (this.formType === 1) {
            https.request({
              method: 'put',
              url: `extscreenapi/plugin/hili/esPluginMac/edit`,
              data: {
                id: this.devicesId,
                bigPluginType: this.formEdit.bigPluginType,
                macs: this.formEdit.macs,
                pluginId: this.formEdit.pluginId,
                pluginVerId: this.formEdit.pluginVerId,
                deadline: this.formEdit.deadline,
                remarks: this.formEdit.remarks
              }
            }).then(res => {
              if (res.code === 200) {
                this.$Message.success('修改成功')
                this.loadData()
                this.devicesId = ''
                this.isShowEdit = false
              } else {
                this.$Message.error(res.message)
              }
            }).catch(error => {
              this.$Message.error(error)
            })
          } else if (this.formType === 0) {
            https.request({
              method: 'post',
              url: `extscreenapi/plugin/hili/esPluginMac/add`,
              data: {
                bigPluginType: this.formEdit.bigPluginType,
                macs: this.formEdit.macs,
                pluginId: this.formEdit.pluginId,
                pluginVerId: this.formEdit.pluginVerId,
                deadline: this.formEdit.deadline,
                remarks: this.formEdit.remarks
              }
            }).then(res => {
              this.$Message.success('新增成功')
              this.loadData()
              this.isShowEdit = false
            }).catch(error => {
              this.$Message.error(error)
            })
          }
        } else {
          this.changeLoading()
        }
      })
    },
    // 表格排序
    sortChange (data) {
      if (data.order !== 'normal') {
        this.sort = [data.key, data.order].join(' ')
        this.loadData()
      }
    },
    // 页数切换
    pageChange (page) {
      this.current = page
      this.loadData()
    },
    // 每页条数控制
    pageSizeChange (size) {
      this.pageSize = size
      this.current = 1
      console.log(size)
      // this.loadData()
    },
    changeLoading () {
      this.loading = false
      this.$nextTick(() => {
        this.loading = true
      })
    },
    changeAppId (val) {
      this.loadData(val)
    },
    clearAppId () {
      this.loadData()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .container{
    position: relative;
  }
  .file-wrap {
    position: relative;
    display: inline-block;
    .file-input {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
  }
  .spacingTwice{
    margin-top:30px;
  }
  .select-box{
    display: flex;
    position: absolute;
    top: 20px;
    left: 160px;
    .select-label{
      line-height: 32px;
      margin-right: 10px;
    }
  }
    .input_left{
    // left:516px;
    left:131px;
  }
  .input_left_two{
    // left:700px;
    left:300px;
  }
  .input_left_three{
    // left:885px;
    left:466px;
  }
</style>



// WEBPACK FOOTER //
// src/components/testMacSdk.vue